import React from "react";
import { useSelector } from "react-redux";
import type { AppState } from "../../../../store";
import { getTransformedPrescriptionItems } from "../../../../store/prescription/selectors";
import type { DispensationTableProps, ItemInterface } from "./types";
import { handleCanDispense } from "./utils/dispensationHelpers";
import TableRow from "./components/TableRow";
import * as Styles from "./styles/DispensationTableStyles";

const DispensationTable: React.FC<DispensationTableProps> = ({ onClick }) => {
  const transformedItems = useSelector((state: AppState) =>
    getTransformedPrescriptionItems(state),
  );

  return (
    <Styles.Table>
      <thead>
        <tr>
          <Styles.TableHeader>Item</Styles.TableHeader>
          <Styles.TableHeader>Quantidade Prescrita</Styles.TableHeader>
          <Styles.TableHeader>Quantidade Dispensada</Styles.TableHeader>
          <Styles.TableHeader />
        </tr>
      </thead>
      <tbody>
        {transformedItems.map((item: ItemInterface) => {
          const canDispense = handleCanDispense(item);

          return (
            <TableRow
              key={item.id}
              item={item}
              canDispense={canDispense}
              onClick={onClick}
            />
          );
        })}
      </tbody>
    </Styles.Table>
  );
};

export default DispensationTable;